/**
 * FieldType enum defines the high level field based on which visuals are controlled.
 * Measure in a high level is numeric field and Dimension in a high level is string field.
 *
 * @readonly
 * @enum {string}
 */
const FieldType = {
    MEASURE: 'measure',
    DIMENSION: 'dimension'
};

export default FieldType;
